/**
 * Unique multipliers can be set for each image if they are too big (or too small)
 * The key is the ID of the image, the value is the multiplier
 */
export const multipliers: Record<number, number> = {
  992: 0.9,
  518: 0.95,
}
